module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIdJREFUeNpiOWbjbMDAwBAAxBOsjuz9wEAkYIJqqgfi/UBDBIjVyAhVvB+IQTZfAGJHfDYD1QeAbYQqcoRqMiDC5vUgDHIqAxmawX5kIEczEzKHFM1M6ALEambCZhoxmhnxBQC2qALi9zhtxGczXqcS0AwGLEjOSgBS80lJqzBAdAIH2Q4QYABgjEXU+tId4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/module-analytics/components/down.png
// module id = 1690
// module chunks = 0